import { toast } from "@/view/components/ui/use-toast";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { HandleLeadStatusParams } from "../services/leadsService/handleLeadStatus";
import { leadsService } from "../services/leadsService";

export const useLeadMutations = () => {
  const queryClient = useQueryClient();

  const updateStatus = useMutation({
    mutationFn: (input: HandleLeadStatusParams) =>
      leadsService.handleLeadStatus(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["leads"] });
      toast({
        title: "Lead atualizado com sucesso.",
      });
    },
    onError: (error: any) => {
      const message =
        error?.message ?? "Erro ao atualizar lead. Tente novamente mais tarde.";

      toast({
        variant: "destructive",
        title: message,
      });
    },
  });

  return {
    updateLeadStatus: updateStatus.mutateAsync,
    isUpdatingLeadStatus: updateStatus.isPending,
  };
};
